import {OnDestroy, OnInit, Component} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {Subscription} from 'rxjs';
import {HeaderService} from './services/header.service';
import {Title} from '@angular/platform-browser';
import {AuthService} from './security/auth.service';
import {RolesEnum} from './security/roles.enum';
import {CurrentUser} from '../api/models/current-user';
import {AbstractControl, UntypedFormArray, UntypedFormControl, UntypedFormGroup} from '@angular/forms';

@Component({
    selector: 'app-base',
    template: ``,
    standalone: true
})
export class BaseComponent implements OnInit, OnDestroy {

  public form: UntypedFormGroup;

  public route: ActivatedRoute;
  public routeData: Subscription;
  public currentUserSubscription: Subscription;
  public headerService: HeaderService;
  public titleService: Title;
  public authService: AuthService;

  public viewRoles: RolesEnum[];
  public editRoles: RolesEnum[];
  public deleteRoles: RolesEnum[];
  public hasViewAccess = false;
  public hasEditAccess = false;
  public hasDeleteAccess = false;
  public hasSupportAccess = false;

  private supportRoles: RolesEnum[] = [RolesEnum.Support];

  constructor(
    route: ActivatedRoute,
    headerService: HeaderService,
    titleService: Title,
    authService: AuthService) {
    this.route = route;
    this.headerService = headerService;
    this.titleService = titleService;
    this.authService = authService;
  }

  getFormControl(controlName: string, otherForm?: UntypedFormGroup | AbstractControl): UntypedFormControl {
    if (otherForm) {
      return  otherForm.get(controlName) as UntypedFormControl;
    } else {
      return  this.form.get(controlName) as UntypedFormControl;
    }
  }

  getFormControlArray(controlName: string, otherForm?: UntypedFormGroup | AbstractControl): UntypedFormArray {
    if (otherForm) {
      return  otherForm.get(controlName) as UntypedFormArray;
    } else {
      return  this.form.get(controlName) as UntypedFormArray;
    }
  }

  ngOnInit() {
    this.routeData = this.route.data.subscribe((data) => {
      const meta = data['meta'] ? data['meta'] : {};
      console.log('change title', meta);

      if (meta.title) {
        this.headerService.setTitle(meta.title);
        this.titleService.setTitle(meta.title);
      }
    });

    this.currentUserSubscription = this.authService.currentUser.subscribe((data) => {
      this.hasViewAccess = this.hasAccess(this.viewRoles);
      this.hasEditAccess = this.hasAccess(this.editRoles);
      this.hasDeleteAccess = this.hasAccess(this.deleteRoles);
      this.hasSupportAccess = this.hasAccess(this.supportRoles);
      // console.log('currentUserSubscription');
      this.onCurrentUserChanged(data);
    });

  }

  ngOnDestroy(): void {
    this.routeData?.unsubscribe();
    this.currentUserSubscription?.unsubscribe();
  }

  hasAccess(role: RolesEnum[]): boolean {
    console.log(role);
    return this.authService.hasAccess(role);
  }

  onCurrentUserChanged(user?: CurrentUser): void {

  }
}
